import { MIXPANEL_EVENT_PROPERTIES } from '../../constants';
import { SimpleStore } from '../simple';

export const createProjectIdStore = () =>
    new SimpleStore<typeof MIXPANEL_EVENT_PROPERTIES.PROJECT_ID, string>(MIXPANEL_EVENT_PROPERTIES.PROJECT_ID);
